<template>
  <div v-if="modelType !== 4" class="justify-left full-width">
    <div class="row justify-left no-wrap">
      <q-toggle
        v-if="theModel.Positive !== undefined"
        v-model="theModel.Positive"
        class="q-pa-none toggle-checkbox q-mr-none unset-items-center"
        checked-icon="add"
        color="primary"
        label=""
        dense
        size="xs"
        unchecked-icon="remove"
      />
      
      <!-- address -->
      <!-- <div class="row"> -->
        <!-- roles horizontal list -->
        <div :style="`margin-top: ${modelCategory === 6 ? '0' : '2px'};`" class="row" :class="{ 'address-controls-row no-wrap items-start': modelType === 1 && modelCategory === 6 }">
          <div v-if="modelType === 1 && modelCategory === 6" class="q-mr-xs address-inline-wrap">
          <!-- legacy address-selector temporarily disabled; keep block for easy rollback -->
          <!-- <address-selector v-model="(theModel as SelectionEntityWithRolesFilterSend).Entity"
            :show-delete="true" @onDeleteClick="emitDelete" /> -->
          <address-selector-refactored
            class="q-mt-xs"
            v-model="(theModel as SelectionEntityWithRolesFilterSend).Entity"
            :show-clear="true"
            :show-delete="false"
          />
          </div>
          <div v-if="!isEditing && modelCategory !== 6" class="items-center" style="word-wrap: break-word; float: left; margin-right: 5px;" :class="['q-my-auto', 'cursor-pointer', 
          { 'text-grey-8': modelType === 0 && !(modelValue as SelectionTextFilterSend).Value }]" @click="editElementName">{{ (modelCategory === 1 ? '#' : '')+getElementName }}
          </div>

          <!-- movement storage options -->
          <q-option-group
            v-if="modelType === 10"
            dense
            inline
            multiple
            :model-value="moveFlagSetConditions.map((el) => el.value)"
            @update:model-value="(val) => { changeMoveFlagModel(val)}"
            :options="movementFlagOptions"
            size="xs"
            color="primary"
            type="checkbox"
          />

          <q-input v-if="isEditing && modelType === 0" class="thin-input full-width" autofocus color="grey-4"
            debounce="500" outlined dense style="font-size: 14px !important; padding: 0 !important; margin-top: -3px;" 
            hide-bottom-space v-model="(modelValue as SelectionTextFilterSend).Value" auto-save 
            no-error-icon :rules="[(val: string) => !!val || $t('input_name')]"
            @keydown.esc="isEditing = false" @blur="isEditing = false" @keydown.enter.stop.prevent="saveTextModel"
          />

          <q-btn
            class="q-px-none q-mx-none unset-items-center"
            flat
            dense
            v-if="[1,2,3].includes(modelType) && modelCategory !== 6"
            :aria-label="$t('delete_filter')"
            icon="close"
            size="sm"
            tabindex="-1"
            color="grey-8"
            @click="emitDelete"
          >
            <q-tooltip :delay="1000">
              {{ $t('remove') }}
            </q-tooltip>
          </q-btn>
          <q-btn
            v-if="modelType === 1 && modelCategory === 6"
            class="q-px-none q-mx-none unset-items-center address-delete-btn"
            flat
            dense
            :aria-label="$t('delete_filter')"
            icon="close"
            size="sm"
            tabindex="-1"
            color="grey-8"
            @click="emitDelete"
          >
            <q-tooltip :delay="1000">
              {{ $t('remove') }}
            </q-tooltip>
          </q-btn>
          <div v-if="modelType === 1 && roleOptions && roleOptions.length"
            class="address-roles-trigger cursor-pointer q-ml-xs text-bold text-grey-8"
            @click="($refs.roles_select as any).showPopup()"
            style="margin-top: 3px;">#
          </div>

          <!-- <div v-if="modelType === 1 && roleOptions && roleOptions.length"> -->
            <div class="row no-wrap address-role-chip" v-for="(role, ri) in (modelType === 1 && roleOptions && roleOptions.length ? rolesModel : [])" 
            :key="ri" style="float: left; margin-top: 3px;">
              <div style="word-break: keep-all; white-space: nowrap;">{{ role.label }}</div>
              <q-btn
                class="q-pa-none q-ma-none"
                style="margin-top: 0;"
                flat
                dense
                :aria-label="$t('remove')"
                icon="close"
                size="xs"
                @click="() => { rolesModel = rolesModel.filter((el, index) => index != ri) }"
              />
            </div>
          <!-- </div> -->
        </div>
      <!-- </div> -->
      <!-- <q-space></q-space> -->
    </div>
    <q-select
      flat
      v-if="modelType === 1 && roleOptions && roleOptions.length"
      v-model="rolesModel"
      class="no-select-border q-mb-xs"
      hide-bottom-space
      fill-input
      multiple
      :label-slot="false"
      :bottom-slots="false"
      dense outlined
      :style="'max-width: 40vw; max-height: 0; overflow: hidden;'"
      input-debounce="500"
      label=""
      ref="roles_select"
      :hide-dropdown-icon="true"
      :options="roleOptions"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey">
            {{ $t('no_data_found') }}
          </q-item-section>
        </q-item>
      </template>      
    </q-select>
  </div>



  <!-- Parameters -->
  <div v-else class="row justify-left full-width q-py-xs no-wrap">
    <div class="col q-pl-sm">
      <!-- hide if child elements are selected also -->
      <div class="row justify-left full-width q-pt-none no-wrap">
        <!-- add condition if not a record -->
        <q-btn
          v-if="theModel.Descriptor === 2"
          class="q-my-none unset-items-center" flat dense round icon="add" size="sm" color="grey-8"
          style="margin-top: -2px;"
          :aria-label="$t('add_condition')"
        >
          <q-menu anchor="top right" self="bottom left"
            :ref="(el: any) => { set_menu = el }"
            max-height="1300px"
          >
            <aux-selector
              ref="aux_selector_set"
              :model-value="conditionsModel.filter((el: any) => el.listParam)"
              @update:model-value="(arg: any) => { onAddStringSet(arg); }"
              :input-index="0" :allow-free-input="true"
              :model-type="16" :set-id="(theModel as SelectionParameterFilterStringSetSend).SetId"
              :allow-multiple="true"
              @input-value="(val: any) => { throttledAdd(val); }"
              @selectorClosed="hideSetMenu"
            />
          </q-menu>
        </q-btn>
        <q-btn
          v-else-if="theModel.Descriptor && theModel.Descriptor !== 3"
          class="q-my-none unset-items-center" flat dense round icon="add" size="sm" color="grey-8"
          style="margin-top: -2px;"
          @click="addNewCondition"
          :aria-label="$t('add_condition')"
        />

        <!-- col -->
        <div class="items-center">
          <div class="row no-wrap">
            <!-- Positive-тоггл показываем ТОЛЬКО для корневого параметра (parentElement === undefined).
                 Для дочерних в дереве FieldFilters параметр без conditions невалиден по validateFilters
                 (см. store/validation/index.ts: new_chain.length > 1 && Selected && нет conditions → ошибка),
                 поэтому тоггл «есть/нет» не имеет смысла и должен быть скрыт. -->
            <q-toggle
              v-if="!parentElement && (((theModel.Descriptor !== 3 && (!conditionsModel || !conditionsModel.length)) ||
                (theModel.Descriptor === 3 && (!conditionsModel[0] || !conditionsModel[0].length))) && theModel.Positive !== undefined)"
              v-model="theModel.Positive"
              :class="`q-pa-none toggle-checkbox q-mr-none unset-items-center`"
              style="margin-top: -2px;"
              checked-icon="add"
              color="primary"
              label=""
              size="xs"
              dense
              unchecked-icon="remove"
            />
            <div style="word-wrap: break-word; word-break: break-all;" 
              :class="[{ 'cursor-pointer': theModel.Descriptor }]">{{ getElementName }}
              <q-menu fit v-if="theModel.Descriptor" @before-show="(e: any) => { filter_string = '' }">
                <!-- justify-between  -->
                <div class="row q-mx-sm no-wrap minw-selector">
                  <q-input outlined dense ref="panel_search_input" color="white" 
                    class="full-width thin-input q-my-auto" v-model="filter_string" hide-bottom-space 
                    :placeholder="$t('search_label')" autofocus debounce="100"

                    @keydown.down.exact.prevent="$refs.rec_selector && ($refs.rec_selector as any).trackArrowDown(1)"
                    @keydown.up.exact.prevent="$refs.rec_selector && ($refs.rec_selector as any).trackArrowUp(1)"
                    @keyup.enter="$refs.rec_selector && ($refs.rec_selector as any).selectCurrent()"
                  />
            
                  <q-btn
                    class="q-my-sm q-px-none q-mr-none q-ml-lg"
                    flat
                    dense
                    :aria-label="$t('close_selector')"
                    icon="close"
                    size="md"
                    v-close-popup
                  >
                    <q-tooltip :delay="1000">
                      {{ $t('close_menu') }}
                    </q-tooltip>
                  </q-btn>
                </div>
                <q-separator class="q-my-none q-py-none" />
                <recursive-selector style="max-height: 50vh; overflow: auto;" ref="rec_selector"
                  :elements="parameterOptions" :take-ids-only="true" :hide-checkboxes="true"
                  :allow-multiple="false" :element-type="9" v-model="selectedParameterModel" 
                  return-type="chain" nested-key-name="FieldFilters" entity-inside-name="Parameter"
                  :filter-string="filter_string" />
              </q-menu>
            </div>

            
          </div>
        </div>
        <!-- <q-space></q-space> -->
        <q-btn-toggle
          v-model="(theModel as any).Connector"
          v-if="(theModel as any).Connector"
          class="filter-parameter-toggle q-mr-none"
          style="margin-top: -1px;"
          no-caps
          unelevated
          dense
          toggle-color="primary"
          color="white"
          text-color="accent"
          :options=" [
            { label: $t('or_label'), value: 1 },
            { label: $t('and_label'), value: 2 }
          ]"
        />

        <q-btn
          class="q-px-none q-ml-xs unset-items-center"
          :style="`margin-top: ${conditionsModel && conditionsModel.length ? -2 : -1}px;`"
          flat
          dense
          :aria-label="$t('delete_filter')"
          icon="close"
          size="sm"
          tabindex="-1"
          color="accent"
          @click="emitDelete"
        >
          <q-tooltip :delay="1000">
            {{ $t('remove') }}
          </q-tooltip>
        </q-btn>
      </div>
      <div v-for="(cond, c_index) in conditionsModel" :key="c_index"
        class="row justify-left full-width q-py-none no-wrap" :style="'max-width: 100%;'+([0].includes((cond as any).CompareType) ? 'max-height: 35px;' : '')">
        <!-- TODO: find out why selector ruins the whole conditions model -->
        <q-toggle
          v-if="theModel.Descriptor !== 3"
          v-model="cond.Positive"
          checked-icon="add"
          color="navy"
          size="xs"
          label=""
          dense
          unchecked-icon="remove"
        />
        <!-- in formulas 0 or 1, in other descriptors 0 is immutable -->
        <q-btn-toggle
          v-model="cond.Connector"
          v-if="(theModel.Descriptor === 5 && (cond as any).CompareType || theModel.Descriptor !== 5 && cond.Connector) && c_index > 0"
          :class="`filter-parameter-toggle q-mt-${[2,5].includes(theModel.Descriptor) ? 'sm' : 'sm'}`"
          no-caps
          unelevated
          dense
          toggle-color="primary"
          color="white"
          text-color="accent"
          :options=" [
            { label: $t('or_label'), value: 0 },
            { label: $t('and_label'), value: 1 }
          ]"
        />
        <q-checkbox
          size="sm"
          class="q-pa-none"
          v-if="[2,3].includes((cond as any).CompareType)"
          toggle-indeterminate
          checked-icon="arrow_forward_ios"
          unchecked-icon="arrow_back_ios"
          :false-value="2"
          :true-value="3"
          color="grey-7"
          :indeterminate-value="1"
          @update:model-value="(val: any) => { onCompareToggle(val, c_index) }"
          v-model="(cond as any).CompareType"
        />
        <q-checkbox
          v-if="[0,1].includes((cond as any).CompareType)"
          toggle-indeterminate
          checked-icon="drag_handle"
          unchecked-icon="none"
          color="grey-7"
          :label="[0].includes((cond as any).CompareType) ? $t('not_present') : ''"
          :left-label="[0].includes((cond as any).CompareType)"
          :size="[0].includes((cond as any).CompareType) ? '0' : 'sm'"
          :false-value="0"
          :true-value="1"
          :indeterminate-value="3"
          @update:model-value="(val: any) => { onCompareToggle(val, c_index) }"
          v-model="(cond as any).CompareType"
        />
        <!-- col  -->
        <div class="q-py-none" v-if="(cond as any).CompareType !== 0 || (cond as any).CompareType == undefined">
          <!-- Record = 0,
            String = 1,
            StringSet = 2,
            Bool = 3,
            DateStamps = 4,
            Number = 5 -->

          <div v-if="!textConditionsEditStatuses[c_index] && theModel.Descriptor === 1" :class="['cursor-pointer', 'q-mb-xs', 'q-pt-xs', 
            { 'text-grey-6': !(conditionsModel[c_index] as SelectionTextFilterSend).Value }]" style="margin-top: 1px;" @click="editCondName(c_index)"
          >
            {{ (conditionsModel[c_index] as SelectionTextFilterSend).Value || $t('empty') }}
            <!-- <q-popup-edit v-model="(conditionsModel[c_index] as SelectionTextFilterSend).Value" auto-save fit v-slot="scope">
              <q-input v-model="(conditionsModel[c_index] as SelectionTextFilterSend).Value" outlined dense autofocus 
              no-error-icon debounce="300" @keyup.enter="scope.set" />
            </q-popup-edit> -->
          </div>
          <q-input v-if="textConditionsEditStatuses[c_index] && theModel.Descriptor === 1" class="thin-input full-width" autofocus color="grey-4"
            debounce="500" outlined dense style="font-size: 14px !important; padding: 0 !important; margin-top: 2px;" 
            hide-bottom-space v-model="(conditionsModel[c_index] as SelectionTextFilterSend).Value" 
            no-error-icon :rules="[(val: string) => !!val || $t('input_name')]"
            @keydown.esc="textConditionsEditStatuses[c_index] = false" @blur="textConditionsEditStatuses[c_index] = false" 
            @keydown.enter.stop.prevent="saveCondTextModel(c_index)"
          />
          
          <!-- StringSet -->
          <div v-else-if="theModel.Descriptor === 2" :class="['cursor-pointer', 'q-my-none', 'q-pt-xs' ]">

            <div class="row justify-left full-width no-wrap">
              <div class="items-center" style="word-wrap: break-word;" :class="['q-my-auto', 'cursor-pointer', 
                { 'text-grey-8': !conditionsModel[c_index]?.Name }]">{{ conditionsModel[c_index]?.Name || $t('not_selected_label') }}
                <q-menu anchor="top right" self="bottom left"
                  :ref="(el: any) => { menus[c_index] = el }"
                  max-height="1300px"
                >
                  <aux-selector
                    ref="aux_selector"
                    :model-value="[conditionsModel[c_index]?.selected_value]"
                    @update:model-value="(arg: any) => { onUpdateStringSet(arg, c_index); }"
                    :input-index="0" :allow-free-input="true"
                    :allow-multiple="false"
                    :model-type="16" :set-id="(theModel as SelectionParameterFilterStringSetSend).SetId"
                    @input-value="(val: any) => { throttled(c_index, val); }"
                    @selectorClosed="hideMenu(c_index)"
                  />
                </q-menu>
              </div>
            </div>
          </div>
          <!-- Bool -->
          <div v-else-if="theModel.Descriptor === 3">
            <q-option-group
              dense
              inline
              multiple
              :model-value="conditionsModel[c_index].map((el: any) => el.value)"
              @update:model-value="(val: any) => { changeBoolModel(val, c_index) }"
              :options="boolStatusOptions"
              size="xs"
              color="primary"
              type="checkbox"
            />
          </div>
          <!-- DateStamps -->
          <div v-else-if="theModel.Descriptor === 4" class="row">
            <date-range-display-item :is-parameter="true" v-model="conditionsModel[c_index]" />
          </div>
          <!-- Number -->
          <div v-else-if="theModel.Descriptor === 5" :class="['cursor-pointer', 'q-my-none', 'q-pt-xs']"
          >
            <formula-selector :input-parameter-options="[fullParameterOptions]"
              :nested-key-name="nestedKeyName" :template-name="templateName" :input-index="0"
              v-model="(conditionsModel[c_index] as FormulaInFilter).FormulaTokens" />
          </div>
        </div>
        <!-- <div class="col q-py-md" style="margin-top: 20px;" v-else> -->
          <!-- <q-space></q-space> -->
        <!-- </div> -->
        <q-btn
          v-if="theModel.Descriptor !== 3"
          class="q-px-none q-mx-none q-mt-xs unset-items-center"
          flat
          dense
          :style="`margin-left: 2px; margin-top: ${conditionsModel && conditionsModel.length && [0].includes((conditionsModel[c_index] as any).CompareType) ? 1 : 
          ([1,2].includes(theModel.Descriptor) ? 2 : 0)}px;`"
          :aria-label="$t('delete_filter')"
          icon="close"
          size="sm"
          tabindex="-1"
          color="accent"
          @click="deleteCondition(c_index)"
        >
          <q-tooltip :delay="1000">
            {{ $t('remove') }}
          </q-tooltip>
        </q-btn>
      </div>
      <div class="row justify-left full-width q-pt-none no-wrap">
        <q-select
          v-if="filteringOptions.length"
          :model-value="filteringOptions.find((opt: any) => opt.value === (theModel as any).FilteringOption)"
          @update:model-value="(val: any) => {(theModel as any).FilteringOption = val.value}"
          class="full-width no-select-border thin-input"
          hide-bottom-space
          :bottom-slots="false"
          dense outlined
          input-debounce="500"
          :hide-dropdown-icon="false"
          :options="filteringOptions"
        />
      </div>
    </div>
  </div>
</template>
  
<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
import { SelectionDateStampsFilterSend, SelectionEntityWithRolesFilterSend, SelectionFilterSendPositivity, 
    SelectionParameterFilterStringSetInstanceSelected, 
    SelectionParameterFilterStringSetInstanceTyped, 
    SelectionProjectStageFilterSend, SelectionTextFilterSend, StorageOfMovementFilterDto } from '@/models/interfaces/entity-settings/filters/filters';
import { FilterConnectorType, FormulaInFilterCompareType, SelectionFilterGroupSendCategory, SelectionFilterGroupSendDescriptor, StorageFilterTypeFlagsDto } from '@/models/etc/types';
import { date } from 'quasar';
import { CommonEntity } from '@/models/interfaces/common';
import { FormulaInFilter, SelectionParameterFilterBoolSend, SelectionParameterFilterDateStampsSend, SelectionParameterFilterNumberSend, 
  SelectionParameterFilterSend, SelectionParameterFilterStringSend, SelectionParameterFilterStringSetSend } from '@/models/interfaces/entity-settings/parameters/parameters';
import { BooleanFilterFlags, SelectionParametersFilterSendDescriptor, V2ParameterValueType } from '@/models/etc/parameter-types';
import RecursiveSelector from '@/components/common/basic/recursive-selector/refactored/RecursiveSelector.vue';
import { arrayEquals, findRecursive } from '@/models/helpers/recursive';
import FormulaSelector from '@/components/common/formula-selector/FormulaSelector.vue';
// import AddressSelector from '@/components/common/address-selector/AddressSelector.vue';
import AddressSelectorRefactored from '@/components/common/address-selector/AddressSelectorRefactored.vue';
import DateRangeDisplayItem from '@/components/common/basic/data-components/DateRangeDisplayItem.vue';
// import AuxSelector from '@/components/common/aux-selector/AuxSelector.vue';
import { reactive } from 'vue';
import { useDebounceFn } from '@vueuse/core';
import { i18n } from '../../../../i18n';
import { generalStore } from '@/store/general';
  
function formatDate(arg: any) {
  return arg ? date.formatDate(new Date(""+arg), 'DD.MM.YYYY') : i18n.global.t('not_set_condition')
}

@Component({
  name: 'VariableDisplayItem',
  components: { RecursiveSelector, FormulaSelector, /* AddressSelector, */ AddressSelectorRefactored, DateRangeDisplayItem/*, AuxSelector*/ }
})
export default class VariableDisplayItem extends Vue {
  @Prop({ default: SelectionFilterGroupSendDescriptor.Text })
  modelType!: SelectionFilterGroupSendDescriptor
  @Prop({ default: SelectionFilterGroupSendCategory.Name })
  modelCategory!: SelectionFilterGroupSendCategory
  @Prop({ default: {} as SelectionFilterSendPositivity })
  modelValue!: any
  @Emit("update:modelValue") emitModelValue(arg: SelectionFilterSendPositivity) { return arg; }
  @Emit("onDeleteClick") emitDelete(arg: any) { return arg; }

  after_add: boolean = false
  isEditing: boolean = false
  textConditionsEditStatuses: boolean[] = []

  // limited parameter options for fields replacing
  @Prop({ default: [] })
  parameterOptions?: any[]
  // full parameter options for formula selector
  @Prop({ default: [] })
  fullParameterOptions?: any[]
  @Prop({ default: false })
  hasSelectedChildren?: boolean

  isShowingMenu: boolean = false

  menus: any[] = reactive([])
  set_menu: any = reactive({})

  @Prop({ default: [] })
  roleOptions?: any[]
  @Prop({ default: '' })
  compoundName?: string
  @Prop({ default: [] })
  idChain?: number[]
  @Prop({ default: undefined })
  parentElement: any
  
  nestedKeyName = "FieldFilters"
  templateName = "Parameter"
  filter_string: string = ''

  throttled: any
  throttledAdd: any

  genstore: any = undefined;

  // compound string set model
  stringSetConditions: any[] = reactive([])
  boolSetConditions: any[] = reactive([])
  moveFlagSetConditions: any[] = reactive([])

  @Watch('filter_string')
  // change focus from search field to list when up and down arrow keys are pressed
  focusPanel() {
    const that = this
    setTimeout(() => {
      that.$refs.rec_selector && (that.$refs.rec_selector as any).trackArrowDown(1, true)
    }, 100)
  }

  get filteringOptions() {

    const closestParent = findRecursive(function a(element: any, el_to_find: any): any | undefined {
      if (!element) return undefined

      if (element['FieldFilters']) {
        if (element['FieldFilters'].includes(el_to_find)) {
          return element;
        } else {
          return findRecursive(a, el_to_find, element['FieldFilters'])
        }
      }
      return undefined
    }, this.theModel, [this.parentElement])

    if (this.theModel.ValueType !== V2ParameterValueType.Record && closestParent && closestParent.IsList) {
      return [
        { label: this.$t('do_not_filter'), value: 1 },
        { label: this.$t('filter_only_list'), value: 2 },
        { label: this.$t('filter_list_and_connected'), value: 3 }
      ]
    } else if (this.theModel.ValueType !== V2ParameterValueType.Record && this.theModel.IsList) {
      return [
        { label: this.$t('do_not_filter'), value: 1 },
        { label: this.$t('filter_only_list'), value: 2 }
      ]
    }
    return []
  }

  onCompareToggle(val: any, ind: number) {
    if (this.conditionsModel && this.conditionsModel[ind]) {
      if (!val) {
        this.conditionsModel[ind].Connector = 0;
      }
    }
  }

  editElementName() {
    // for text nodes only
    if (this.modelType === 0) {
      this.isEditing = true
    }
  }

  editCondName(ind: number) {
    // for text nodes only
    if (this.modelType === 4) {
      this.textConditionsEditStatuses[ind] = true
    }
  }

  saveTextModel() {
    // 510 in order to set more than the 500ms debounce; because if set earlier, debounce is not fired and the model is not saved
    setTimeout(() => { this.isEditing = false; }, 510);
  }

  saveCondTextModel(ind: number) {
    // 510 in order to set more than the 500ms debounce; because if set earlier, debounce is not fired and the model is not saved
    setTimeout(() => { this.textConditionsEditStatuses[ind] = false; }, 510);
  }

  hideMenu(ind: number) {
    this.menus[ind] && (this.menus[ind].hide());
  }

  hideSetMenu() {
    this.set_menu && (this.set_menu.hide());
  }

  mounted() {
    if (this.theModel.Descriptor === SelectionParametersFilterSendDescriptor.StringSet) {
      const text_cond = (this.theModel as SelectionParameterFilterStringSetSend).TextConditions
      .map(el => {
        return {
          Positive: el.Positive,
          Position: el.Position,
          listParam: false,
          Name: el.Value,
          Id: 0,
          selected_value: {
            listParam: false,
            Name: el.Value,
            Id: 0
          }
        }
      })
      
      const ent_cond = (this.theModel as SelectionParameterFilterStringSetSend).EntityConditions
      .map(el => {
        return {
          Positive: el.Positive,
          Position: el.Position,
          listParam: el.Entity ? true : false,
          Name: el.Entity ? el.Entity.Name : '',
          Id: el.Entity ? el.Entity.Id : 0,
          selected_value: el.Entity ? {
            Id: el.Entity.Id,
            Name: el.Entity.Name,
            listParam: true
          } : {
            listParam: false,
            Name: '',
            Id: 0
          }
        }
      })
      // sort
      this.stringSetConditions = reactive([ ...text_cond, ...ent_cond ].sort((el1, el2) => el1.Position - el2.Position))
    }

    if (this.theModel.Descriptor === SelectionParametersFilterSendDescriptor.Bool) {
      this.boolSetConditions = [this.boolStatusOptions.filter((mask: any) => {
        return ((this.theModel as SelectionParameterFilterBoolSend).BoolFlags & mask.value) !== 0
      })]
    }

    if (this.modelType === SelectionFilterGroupSendDescriptor.StoragesOfMovement) {
      this.moveFlagSetConditions = this.movementFlagOptions.filter((mask: any) => {
        return ((this.theModel as StorageOfMovementFilterDto).TypeFlags & mask.value) !== 0
      })
    }

    if (this.modelType === 0 && this.theModel && !(this.theModel as SelectionTextFilterSend).Value) {
      this.isEditing = true
    }
  }

  // movement flags model
  movementFlagName(arg: number): string {
    switch (arg) {
      case StorageFilterTypeFlagsDto.Receiver:
        return this.$t("storage_receiver");
      case StorageFilterTypeFlagsDto.Source:
        return this.$t("storage_source");
      case StorageFilterTypeFlagsDto.None:
      default:
        return this.$t("filter_empty");
    }
  }

  get movementFlagOptions() {
    switch (this.modelType) {
      case SelectionFilterGroupSendDescriptor.StoragesOfMovement:
        return Object.values(StorageFilterTypeFlagsDto)
          .filter((v) => !isNaN(Number(v)) && Number(v) > 0)
          .map((vm) => {
            return {
              label: this.movementFlagName(Number(vm)),
              value: Number(vm),
            };
          });
      default:
        return [];
    }
  }

  changeMoveFlagModel(val: any) {
    if (!this.theModel ||
    this.modelType !== SelectionFilterGroupSendDescriptor.StoragesOfMovement) { return }
    this.moveFlagSetConditions = this.movementFlagOptions.filter((el: any) => val.includes(el.value))
  }

  // update single condition
  onUpdateStringSet(arg: any, ind: number) {
    if (!this.conditionsModel[ind]) { return }

    if (!arg || !arg.length) {
      this.conditionsModel[ind] = {
        Positive: this.conditionsModel[ind].Positive,
        Position: this.conditionsModel[ind].Position,
        listParam: false,
        Name: '',
        Id: 0,
        selected_value: {
          listParam: false,
          Id: 0,
          Name: ''
        }
      }
    } else {
      // delete condition if selected Id already exists
      const ind_f = this.conditionsModel.findIndex((el: any) => arg[0].Id ? (el.Id === arg[0].Id) : (el.Name === arg[0].Name))
      if (ind_f >= 0 && ind_f != ind) {
        this.deleteCondition(ind)
      } else {
        this.conditionsModel[ind] = {
          Positive: this.conditionsModel[ind].Positive,
          Position: this.conditionsModel[ind].Position,
          listParam: arg[0].Id ? true : false,
          Name: arg[0].Name,
          Id: arg[0].Id ? arg[0].Id : 0,
          selected_value: arg[0].Id ? {
            Id: arg[0].Id,
            Name: arg[0].Name,
            listParam: true
          } : {
            Id: 0,
            Name: arg[0].Name,
            listParam: false
          }
        }
      }
    }
  }

  // set multiple conditions
  onAddStringSet(arg: any) {
    this.after_add = true;
    if (this.modelType === SelectionFilterGroupSendDescriptor.Parameters && 
    this.theModel.Descriptor as SelectionParametersFilterSendDescriptor === SelectionParametersFilterSendDescriptor.StringSet) {
      const preserve_arr = new Map()
      for (let c_ind = (this.conditionsModel as any[]).length-1; c_ind >= 0; c_ind--) {
        preserve_arr.set((this.conditionsModel as any[])[c_ind].Id, {
          Position: (this.conditionsModel as any[])[c_ind].Position,
          Positive: (this.conditionsModel as any[])[c_ind].Positive
        });
        (this.conditionsModel as any[])[c_ind].listParam && ((this.conditionsModel as any[]).splice(c_ind, 1));
      }

      if (arg && arg.length) {
        for (let c_ind = 0; c_ind < arg.length; c_ind++) {
          if (!arg[c_ind].Id) { return }
          
          this.addStringSetFilter();
          
          this.conditionsModel[this.conditionsModel.length-1] = {
            Positive: preserve_arr.has(arg[c_ind].Id) ? preserve_arr.get(arg[c_ind].Id).Positive : this.conditionsModel[this.conditionsModel.length-1].Positive,
            Position: preserve_arr.has(arg[c_ind].Id) ? preserve_arr.get(arg[c_ind].Id).Position : this.conditionsModel[this.conditionsModel.length-1].Position,
            listParam: true,
            Name: arg[c_ind].Name,
            Id: arg[c_ind].Id,
            selected_value: {
              Id: arg[c_ind].Id,
              Name: arg[c_ind].Name,
              listParam: true
            }
          }
        }

        // console.log(this.conditionsModel)
        // sort
        this.stringSetConditions = reactive((this.conditionsModel as any[]).sort((el1, el2) => el1.Position - el2.Position))
      }
    }
  }

  @Watch('stringSetConditions', { deep: true })
  cond_watcher(val: any[]) {
    const text_cond: any[] = []
    const ent_cond: any[] = []

    console.log('cond change')
    console.log(val)

      for (let p_index = 0; p_index < val.length; p_index++) {
        if (val[p_index] && val[p_index].selected_value && 
        (val[p_index].selected_value.listParam || val[p_index].Name == '')) {
          ent_cond.push({
            Positive: val[p_index].Positive,
            Position: val[p_index].Position,
            Entity: val[p_index].Name !== '' ? val[p_index].selected_value : null
          } as SelectionParameterFilterStringSetInstanceSelected)
        } else if (val[p_index]) {
          text_cond.push({
            Positive: val[p_index].Positive,
            Position: val[p_index].Position,
            Value: val[p_index].Name
          } as SelectionParameterFilterStringSetInstanceTyped)
        }
      }

    (this.theModel as SelectionParameterFilterStringSetSend).TextConditions = text_cond;
    (this.theModel as SelectionParameterFilterStringSetSend).EntityConditions = ent_cond;

    // console.log(this.theModel)
  }

  @Watch('boolSetConditions', { deep: true })
  bool_cond_watcher(val: any[]) {
    if (this.theModel.Descriptor !== SelectionParametersFilterSendDescriptor.Bool) { return }
    (this.theModel as SelectionParameterFilterBoolSend).BoolFlags = 0
    if (!val[0] || !val[0].length) { return }

    val[0].forEach((el: any) => {
      (this.theModel as SelectionParameterFilterBoolSend).BoolFlags |= el.value;
    })
  }

  @Watch('moveFlagSetConditions', { deep: true })
  move_flats_watcher(val: any[]) {
    if (this.modelType !== SelectionFilterGroupSendDescriptor.StoragesOfMovement) { return }
    (this.theModel as StorageOfMovementFilterDto).TypeFlags = 0
    if (!val || !val.length) { return }

    val.forEach((el: any) => {
      (this.theModel as StorageOfMovementFilterDto).TypeFlags |= el.value;
    })
  }

  // bool status flags filter
  boolStatusName(arg: number): string {
    switch (arg) {
      case BooleanFilterFlags.Null:
        return this.$t('not_selected_label')
      case BooleanFilterFlags.False:
        return this.$t('no_label_upcase')
      case BooleanFilterFlags.True:
        return this.$t('yes_label_upcase')
      case BooleanFilterFlags.Nothing:
      default:
        return this.$t('presence_upcase')
    }
  }

  get boolStatusOptions() {
    switch (this.theModel?.Descriptor) {
      case SelectionParametersFilterSendDescriptor.Bool:
        return Object.values(BooleanFilterFlags)
        .filter((v) => !isNaN(Number(v)) && Number(v) > 0)
        .map((vm) => {
          return {
            label: this.boolStatusName(Number(vm)),
            value: Number(vm)
          }
        })
      default:
        return []
    }
  }

  get theModel(): any {
    return this.modelValue
  }

  set theModel(val: any) {
    this.emitModelValue(val)
  }

  // filter roles model
  get rolesModel(): any[] {
    if (!this.theModel) return []
    return (this.theModel as SelectionEntityWithRolesFilterSend).Roles.map((el: any) => {
      return {
        label: el.Name,
        value: el
      }
    })
  }

  set rolesModel(val: any[]) {
    if (!this.theModel) return

    const theonly_index = (val as any[]).findIndex(el => el.value.TheOnlyOption);
    let val_filtered: any[] = []
    if (theonly_index > -1) {
      // toggle
      if (theonly_index >= 0 && (this.theModel as SelectionEntityWithRolesFilterSend).Roles
      .includes(val[theonly_index].value)) {
        val_filtered = val
        val_filtered.splice(theonly_index, 1)
      } else {
        val_filtered = [val[theonly_index]]
      }
    } else {
      val_filtered = val
    }

    (this.$refs.roles_select as any).hidePopup();

    (this.theModel as SelectionEntityWithRolesFilterSend).Roles = val_filtered.map((el: any) => {
      return el.value
    })
  }

  // parameters model for fields exchange
  get selectedParameterModel(): any {
    if (this.modelType !== SelectionFilterGroupSendDescriptor.Parameters) { return [] }
    return [ this.idChain ]
  }

  set selectedParameterModel(val: any) {
    if (this.theModel) {
      this.theModel.Selected = false;
      this.theModel.Positive != undefined && (this.theModel.Positive = false);

      if (this.parameterOptions && val[0]) {
        const found_el = findRecursive(function a(element: any, el_to_find: any): any | undefined {
          if (!element) return undefined

          if (arrayEquals([ ...el_to_find.chain, element.Parameter.Id ], el_to_find.chain_to_find)) {
            return element;
          }
          if (element['FieldFilters']) {
            return findRecursive(a, {
              chain: [ ...el_to_find.chain, element.Parameter.Id ], 
              chain_to_find: el_to_find.chain_to_find
            }, element['FieldFilters'])
          }
          return undefined
        }, { chain: [], chain_to_find: val[0] }, this.parameterOptions)

        if (found_el) {
          found_el.Selected = true
          found_el.Positive != undefined && (found_el.Positive = true);
        }
      }
    }
  }

  created() {
    this.genstore = generalStore();
    
    this.throttled = useDebounceFn((c_index: number, val: string) => {
      this.createStringSetValue(c_index, val)
    }, 500)

    this.throttledAdd = useDebounceFn((val: string) => {
      if (this.modelType === SelectionFilterGroupSendDescriptor.Parameters && 
      this.theModel.Descriptor as SelectionParametersFilterSendDescriptor === SelectionParametersFilterSendDescriptor.StringSet) {
        this.addStringSetFilter();
        this.createStringSetValue(this.conditionsModel.length-1, val)
      }
    }, 500)
  }

  get conditionsModel(): any {
    if (this.modelType === SelectionFilterGroupSendDescriptor.Parameters) {

      switch (this.theModel.Descriptor as SelectionParametersFilterSendDescriptor) {
        case SelectionParametersFilterSendDescriptor.DateStamps:
          return (this.theModel as SelectionParameterFilterDateStampsSend).Conditions
        case SelectionParametersFilterSendDescriptor.Number:
          return (this.theModel as SelectionParameterFilterNumberSend).Formulas
        case SelectionParametersFilterSendDescriptor.StringSet:
          return this.stringSetConditions
        case SelectionParametersFilterSendDescriptor.String:
          if (this.textConditionsEditStatuses.length !== (this.theModel as SelectionParameterFilterStringSend).Conditions.length) {
            this.textConditionsEditStatuses = reactive((this.theModel as SelectionParameterFilterStringSend).Conditions
              .map((el, ind) => ind === (this.theModel as SelectionParameterFilterStringSend).Conditions.length-1 && !el.Value && this.after_add))
          }
          return (this.theModel as SelectionParameterFilterStringSend).Conditions
        case SelectionParametersFilterSendDescriptor.Bool:
          return this.boolSetConditions
        /* falls through */
        case SelectionParametersFilterSendDescriptor.Record:
        default:
          return [] // bool flags here
      }
    }
    return []
  }

  createStringSetValue(c_index: number, val: string) {
    const ind_f = this.conditionsModel.findIndex((el: any) => !el.listParam && (el.Name === val))
    if (ind_f > 0 && ind_f != c_index) {
      this.deleteCondition(c_index)
    } else {
      this.conditionsModel[c_index] = {
        Positive: this.conditionsModel[c_index].Positive,
        Position: this.conditionsModel[c_index].Position,
        listParam: false,
        Name: val,
        Id: 0,
        selected_value: {
          listParam: false,
          Name: val,
          Id: 0
        }
      }
    }
  }

  deleteCondition(c_index: number) {
    console.log('del '+c_index)
    if (this.modelType === SelectionFilterGroupSendDescriptor.Parameters) {
      switch (this.theModel.Descriptor as SelectionParametersFilterSendDescriptor) {
        case SelectionParametersFilterSendDescriptor.DateStamps:
        case SelectionParametersFilterSendDescriptor.String:
          (this.theModel as any).Conditions.splice(c_index, 1)
          break;
        case SelectionParametersFilterSendDescriptor.Number:
          (this.theModel as SelectionParameterFilterNumberSend).Formulas.splice(c_index, 1)
          break;
        case SelectionParametersFilterSendDescriptor.StringSet:
          this.stringSetConditions.splice(c_index, 1)
          break;
        case SelectionParametersFilterSendDescriptor.Bool:
        /* falls through */
        case SelectionParametersFilterSendDescriptor.Record:
        default:
          break;
      }
    }
  }

  changeBoolModel(val: any, c_index: number) {
    if (!this.conditionsModel || !this.conditionsModel[c_index] ||
    this.modelType !== SelectionFilterGroupSendDescriptor.Parameters ||
    this.theModel.Descriptor as SelectionParametersFilterSendDescriptor !== SelectionParametersFilterSendDescriptor.Bool) { return }

    // console.log(this.boolStatusOptions.filter((el: any) => val.includes(el.value)))
    this.boolSetConditions = [this.boolStatusOptions.filter((el: any) => val.includes(el.value))]
  }

  set conditionsModel(val: any[]) {
    if (this.modelType === SelectionFilterGroupSendDescriptor.Parameters) {
      switch (this.theModel.Descriptor as SelectionParametersFilterSendDescriptor) {
        case SelectionParametersFilterSendDescriptor.DateStamps:
          (this.theModel as SelectionParameterFilterDateStampsSend).Conditions = val
          break;
        case SelectionParametersFilterSendDescriptor.Number:
          (this.theModel as SelectionParameterFilterNumberSend).Formulas = val
          break;
        case SelectionParametersFilterSendDescriptor.StringSet:
          this.stringSetConditions = val
          break;
        case SelectionParametersFilterSendDescriptor.String:
          (this.theModel as SelectionParameterFilterStringSend).Conditions = val
          break;
        case SelectionParametersFilterSendDescriptor.Bool:
          this.boolSetConditions = val
          break;
        case SelectionParametersFilterSendDescriptor.Record:
        default:
          return
      }
    }
  }

  get getElementName(): string {
    if (this.compoundName) { return this.compoundName }

    switch (this.modelType) {
      case SelectionFilterGroupSendDescriptor.Text:
        return (this.theModel as SelectionTextFilterSend).Value || this.$t('untitled')
      case SelectionFilterGroupSendDescriptor.Parameters:
        return (this.theModel as SelectionParameterFilterSend).Parameter.Name || this.$t('untitled')
      case SelectionFilterGroupSendDescriptor.EntityWithRoles:
        return ((this.theModel as SelectionEntityWithRolesFilterSend).Entity ? 
          (this.theModel as SelectionEntityWithRolesFilterSend).Entity.Name : (this.theModel as CommonEntity).Name)
      case SelectionFilterGroupSendDescriptor.Datestamps:
        return formatDate((this.theModel as SelectionDateStampsFilterSend).StartDate) +' - '+ 
          ((this.theModel as SelectionDateStampsFilterSend).EndDateIsToday ? this.$t('today_label') : formatDate((this.theModel as SelectionDateStampsFilterSend).EndDate))
      case SelectionFilterGroupSendDescriptor.ProjectStages:
        return (this.theModel as SelectionProjectStageFilterSend).Stage.Name
      case SelectionFilterGroupSendDescriptor.StoragesOfItem:
        return (this.theModel as CommonEntity).Name
      case SelectionFilterGroupSendDescriptor.StoragesOfMovement:
        return ((this.theModel as StorageOfMovementFilterDto).Storage ? 
          (this.theModel as StorageOfMovementFilterDto).Storage.Name : (this.theModel as CommonEntity).Name)
      default:
        return this.$t('untitled')
    }
  }

  get getElementRoles(): string {
    switch (this.modelType) {
      case SelectionFilterGroupSendDescriptor.EntityWithRoles:
        return ((this.theModel as SelectionEntityWithRolesFilterSend).Roles ? 
          (this.theModel as SelectionEntityWithRolesFilterSend).Roles.map((el:any) => el.Name).join(', ') : '')
      default:
        return ''
    }
  }

  // Parameters conditions addition methods
  addTextFilter() {
    const new_el: SelectionTextFilterSend = {
      Positive: true,
      Value: ''
    };
    // @ts-ignore
    (this.conditionsModel as SelectionTextFilterSend).push(new_el)
  }

  // Parameters conditions addition methods
  addStringSetFilter() {
    const new_el: any = {
      Positive: true,
      Position: (this.conditionsModel as any[]).length,
      listParam: false,
      Name: '',
      Id: 0,
      selected_value: {
        listParam: false,
        Name: '',
        Id: 0
      }
    };
    // @ts-ignore
    (this.conditionsModel as any).push(new_el)
  }

  addFormulaFilter() {
    const new_el: FormulaInFilter = {
      Positive: true,
      CompareType: FormulaInFilterCompareType.Equal,
      FormulaTokens: [],
      Connector: FilterConnectorType.Or
    };
    // @ts-ignore
    (this.conditionsModel as SelectionTextFilterSend).push(new_el)
  }

  addDateFilter() {
    const def_date = new Date();
    // def_date.setHours(0)
    // def_date.setMinutes(0)
    // def_date.setSeconds(0)
    // def_date.setMilliseconds(0)

    const new_el: SelectionDateStampsFilterSend = {
      Positive: true,
      StartDate: def_date,
      EndDate: def_date,
      EndDateIsToday: false
    };
    // @ts-ignore
    (this.conditionsModel as SelectionDateStampsFilterSend[]).push(new_el)
  }

  addNewCondition() {
    this.after_add = true;
    if (this.modelType === SelectionFilterGroupSendDescriptor.Parameters) {
      switch (this.theModel.Descriptor as SelectionParametersFilterSendDescriptor) {
        case SelectionParametersFilterSendDescriptor.DateStamps:
          this.addDateFilter();
          break;
        case SelectionParametersFilterSendDescriptor.Number:
          this.addFormulaFilter();
          break;
        case SelectionParametersFilterSendDescriptor.StringSet:
          this.addStringSetFilter();
          break;
        case SelectionParametersFilterSendDescriptor.String:
          this.addTextFilter();
          break;
        case SelectionParametersFilterSendDescriptor.Bool:
          // this.addBoolFilter();
          break;
        case SelectionParametersFilterSendDescriptor.Record:
        default:
          return
      }
    }
  }
}
</script>
  
<style lang="scss">
.filter-parameter-toggle {
  margin: 2px 12px 2px 6px;
  .q-btn--dense {
    padding: 0 12px !important;
    line-height: normal !important;
    min-height: 1.25rem;
    max-height: 1.25rem;
  }

  & > .q-btn-item {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
}

.toggle-checkbox, .toggle-checkbox > * {
  .q-checkbox__inner {
    height: 30px !important;
    min-width: 30px !important;
    width: 30px !important;
  }
}

.address-controls-row {
  width: 100%;
  min-width: 0;
}

.address-inline-wrap {
  min-width: 0;
  flex: 0 1 auto;
}

.address-roles-trigger,
.address-role-chip {
  flex: 0 0 auto;
}

.address-delete-btn {
  flex: 0 0 auto;
}
</style>